// ADV-268: the profile's new-password rule, as the Sicherheit hint states it — at least 10
// characters, one digit and one special character. A special character is anything but a letter,
// a digit or whitespace, so ä/ß count as letters. RegExp() keeps the `u` flag out of the TS
// target check.
const SPECIAL_CHAR = new RegExp('[^\\p{L}\\p{N}\\s]', 'u');
export const STRONG_PASSWORD_MIN_LENGTH = 10;
export const isStrongPassword = (value) => typeof value === 'string'
    && value.length >= STRONG_PASSWORD_MIN_LENGTH
    && /\d/.test(value)
    && SPECIAL_CHAR.test(value);
